<!-- <div *ngIf="widget$| async as widgetDetail"> -->
    <div class="dashboard-label-container radius-s border-light" [ngClass]="spinnerState? 'progress':''">
        <div class="body-wrapper radius-s" *ngIf="!spinnerState && !errorhandlelabeldwidget.status && widgetDetail"
            [ngClass]="widgetDetail.widgetDetails?.className">
            <div class="body-wrapper-left">
                <div class="header-wrapper">
                    <div class="header-left">
     
                    </div> 
                    <div class="header-right">
                        <h1 class=" bold-text">{{widgetDetail.widgetDetails?.contentValue}}</h1>
                    </div>
                </div>
                <div class="footer-wrapper">
                    <p class="content-l m-0 black-text ">{{widgetDetail.widgetDetails?.subTitle}}</p>
                </div>
            </div> 
            <div class="body-wrapper-right">
                <img *ngIf="labelhaserror" [tooltip]="widgetDetail.error?.error.errmsg"
                    src="assets/widgets/asterisk-solid.svg">
            </div>
    
        </div>
        <!-- mat spinner is loaded until widget details loaded from api -->
        <ng-container *ngIf="spinnerState">
            <mat-spinner class="spinner" diameter=20></mat-spinner>
    
        </ng-container>
        <ng-container *ngIf="errorhandlelabeldwidget.status">
            <div class="dashboardwidget-nodata">
                <div class="nodata-img">
                    <img src="assets/widgets/empty-data.svg">
                </div>
                <div>
                    <p class="m-0 content-s secondary-text">{{errorhandlelabeldwidget.errmsg | limitCharacter:18}}</p>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- </div> -->